import { useEffect, useState } from "react";
import { StickyNote } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const BookNotes = () => {
    const [notes, setNotes] = useState([]);

    useEffect(() => {
        fetch(`${API}/api/blog/posts?full=1`)
            .then((r) => r.json())
            .then((d) => setNotes((d.posts || []).slice(0, 4)))
            .catch(() => {});
    }, []);

    if (notes.length === 0) return null;

    return (
        <section data-testid="book-notes-section" className="py-20 px-6 sm:px-8">
            <div className="max-w-5xl mx-auto">
                <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-[#A67C56]">
                    <StickyNote size={14} /> Book Notes
                </span>
                <h2 className="font-serif text-3xl md:text-4xl mt-3 leading-tight">
                    Short reads about <span className="italic text-[#C4956A]">good reads</span>
                </h2>
                <div className="mt-8 grid md:grid-cols-2 gap-5">
                    {notes.map((n) => (
                        <div
                            key={n.slug}
                            data-testid={`book-note-${n.slug}`}
                            className="rounded-2xl bg-white border border-[#E5D7C5] p-6 shadow-soft"
                        >
                            <p className="text-[11px] uppercase tracking-widest font-semibold text-[#C4956A]">
                                {n.category} · {n.date}
                            </p>
                            <h3 className="font-serif text-xl mt-2 leading-snug">{n.title}</h3>
                            <div className="mt-3 space-y-2">
                                {(n.paragraphs || [n.excerpt]).map((p) => (
                                    <p key={p} className="text-sm text-[#6B655C] leading-relaxed">{p}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
